import { jsPDF } from "jspdf";
import { helpQR, imgVertical } from "../dataImg";

function normalizeValue(value, fallback = "-") {
  const normalizedValue = String(value ?? "").trim();
  return normalizedValue || fallback;
}

function normalizeCopies(copies) {
  const parsedCopies = Number.parseInt(String(copies ?? ""), 10);
  return Number.isFinite(parsedCopies) && parsedCopies > 0 ? parsedCopies : 2;
}

function sanitizeFileNamePart(value) {
  return normalizeValue(value, "order").replace(/[^a-z0-9_-]/gi, "_");
}

function drawField(doc, { label, value, x, y, width }) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(label, x, y);

  const labelWidth = doc.getTextWidth(label);
  doc.setLineWidth(0.4);
  doc.line(x, y + 1.2, x + labelWidth, y + 1.2);

  doc.setFontSize(11.5);
  const valueLines = doc.splitTextToSize(normalizeValue(value), width);
  doc.text(valueLines, x, y + 10);
}

function renderPalletLabelPage(doc, labelData) {
  doc.addImage(imgVertical, "png", 10, 10, 45, 64, "", "FAST");
  doc.addImage(helpQR, "png", 14, 78, 18, 18, "", "FAST");

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.text("help.perfectmoose.com", 11, 99);

  drawField(doc, {
    label: "ORDERNR.",
    value: labelData.orderNumber,
    x: 70,
    y: 20,
    width: 74,
  });

  drawField(doc, {
    label: "CUSTOMER REF.",
    value: labelData.customerReference,
    x: 70,
    y: 49,
    width: 74,
  });

  drawField(doc, {
    label: "CUSTOMER NAME.",
    value: labelData.customerName,
    x: 70,
    y: 78,
    width: 74,
  });
}

function printPalletLabels(labelData) {
  const copies = normalizeCopies(labelData?.copies);
  const formattedLabelData = {
    orderNumber: normalizeValue(labelData?.orderNumber),
    customerReference: normalizeValue(labelData?.customerReference),
    customerName: normalizeValue(labelData?.customerName),
  };

  const doc = new jsPDF("l", "mm", [104, 159]);

  for (let copyIndex = 0; copyIndex < copies; copyIndex += 1) {
    if (copyIndex > 0) doc.addPage();
    renderPalletLabelPage(doc, formattedLabelData);
  }

  doc.save(`pallet_label_${sanitizeFileNamePart(formattedLabelData.orderNumber)}.pdf`);
}

export { printPalletLabels };
